

























































































































































































































import moment from 'moment';
import formatValue from '../../utils/fieldMappers/formatValue';
import { detailMap } from '../../utils/fieldMappers/investmentDetailMapper';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue';
import {
  PRODUCT_ALLOCATED_PENSION_CASH,
  PRODUCT_ALLOCATED_PENSION_FIXED,
  PRODUCT_CARE_PLUS,
  PRODUCT_TERM_ALLOCATED_PENSION_CASH,
  PRODUCT_TERM_ALLOCATED_PENSION_FIXED,
} from '../../utils/fieldMappers/constants';
import { getStatementUrl } from '../../api/index';

export default {
  name: 'DetailsTable',
  props: {
    investment: {
      type: Object,
      default: null,
    },
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ScText: Text,
    ScRichText: RichText,
  },
  data: () => ({
    detailMap: detailMap,
    formatValue: formatValue,
    downloading: false,
    dialog: false,
  }),
  computed: {
    isCarePlus: function() {
      return this.investment.accountProductType === PRODUCT_CARE_PLUS;
    },
    field: function() {
      if (this.isActive) {
        return this.detailMap[this.investment.accountProductType].active;
      }
      return this.detailMap[this.investment.accountProductType].closed;
    },
    isRBACashLinked: function() {
      return this.investment.isRBACashLinked;
    },
    isActive: function() {
      if (this.investment.investmentOptions[0].isActive) {
        return true;
      }
      return false;
    },
    showRowOne() {
      return this.rowHasFields(['f1', 'f2', 'f3', 'f4']);
    },
    showRowTwo() {
      return this.rowHasFields(['f5', 'f6', 'f7', 'f8']);
    },
    showRowThree() {
      return this.rowHasFields(['f9', 'f10', 'f11', 'f12']);
    },
    showRowFour() {
      return this.rowHasFields(['f13', 'f14', 'f15', 'f16']);
    },
    showRowFive() {
      return this.investment.noCommission && this.rowHasFields(['f17', 'f18', 'f19', 'f20']);
    },
    dialogWidth() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 345;
      }
      return 576;
    },
  },
  methods: {
    formatLabel: function(label) {
      if (this.investment.isRBACashLinked && label === 'Next payment') {
        return 'Next payment*';
      }
      if (label === 'TTR') {
        return 'TTR*';
      }
      return label;
    },
    rowHasFields(row) {
      for (const fieldNumber of row) {
        if (this.field.hasOwnProperty(fieldNumber)) {
          return true;
        }
      }
      return false;
    },
    showTTR: function() {
      const { accountProductType } = this.investment;
      return (
        accountProductType === PRODUCT_ALLOCATED_PENSION_CASH ||
        accountProductType === PRODUCT_ALLOCATED_PENSION_FIXED
      );
    },
    paymentSuspended(field) {
      if (field && formatValue(field.key, this.investment) === 'Suspended') {
        return true;
      }
      return false;
    },
    downloadStatement(id, name) {
      // We will allow only one download at the time... So check if a download already started
      if (this.downloading) {
        return;
      }

      // Start the Download Spinning
      this.downloading = true;
      this.$router.push(getStatementUrl(id, name)).catch((completed) => {
        // Download will not open a new ROUTE instead navigation will be aborted (next(false)) and Download will start.
        // The Route is only triggered for Analytics purpose - ADOBE
        if (completed == false) {
          // check if there was a business error - document is not available
          if (
            typeof this.$route.meta.docAvailable !== 'undefined' &&
            this.$route.meta.docAvailable === false
          ) {
            // open the popup window
            this.dialog = true;
          } else {
            this.dialog = false;
          }
          // Stop the Download Spinning
          this.downloading = false;
        }
      });
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
